import { Box, CircularProgress } from "@mui/material";
import { keyframes } from "@mui/system";

export function LoadingSpinning() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "100px",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress size={50} />
      </Box>
    </Box>
  );
}
